import FilterWrapperBasicContent from './components/Content.js'
import FilterWrapperBasicSelectPopover from './components/SelectPopover/index.js'
import {SELECT_POPOVERS_ALIGNMENTS} from './components/SelectPopovers/config.js'
import FilterWrapperBasicSelectPopovers from './components/SelectPopovers/index.js'
import FilterWrapperBasicTabs from './components/Tabs.js'

export const BASE_CLASS_NAME = 'mt-FilterWrapperBasic'
export const LABEL_WRAPPER_CLASS_NAME = `${BASE_CLASS_NAME}-labelWrapper`
export const LEGEND_WRAPPER_CLASS_NAME = `${BASE_CLASS_NAME}-legendWrapper`
export const SELECT_POPOVER_CLASS_NAME = `${BASE_CLASS_NAME}-selectPopover`
export const SELECT_POPOVER_CONTENT_CLASS_NAME = `${SELECT_POPOVER_CLASS_NAME}Content`
export const SELECT_POPOVERS_CLASS_NAME = `${BASE_CLASS_NAME}-selectPopovers`
export const SELECT_POPOVERS_ITEM_CLASS_NAME = `${SELECT_POPOVERS_CLASS_NAME}Item`
export const SEARCH_BAR_CLASS_NAME = `${BASE_CLASS_NAME}-searchBar`

export const INPUT_SEARCH_DEBOUNCE = 500
export const INPUT_SEARCH_FILTER_ID = 'input-search-filter-id'

export const NO_OP = () => {}

export const TYPES = {
  BOTTOM_LEFT_POPOVER_TABS_AUTOCLOSE: 'bottomLeftPopoverTabsAutoClose',
  BOTTOM_LEFT_POPOVER_TABS: 'bottomLeftPopoverTabs',
  BOTTOM_LEFT_POPOVER: 'bottomLeftPopover',
  CENTER_TO_CUSTOM_RELATIVE_POPOVER_AUTOCLOSE_SCROLL_INTO_VIEW_WITH_SEARCH_BAR:
    'centerToCustomRelativePopoverAutoCloseScrollIntoViewWithSearchBar',
  CENTER_TO_CUSTOM_RELATIVE_POPOVER_AUTOCLOSE: 'centerToCustomRelativePopoverAutoClose',
  CENTER_TO_CUSTOM_RELATIVE_POPOVER_SCROLL_INTO_VIEW_WITH_SEARCH_BAR:
    'centerToCustomRelativePopoverScrollIntoViewWithSearchBar',
  CENTER_TO_CUSTOM_RELATIVE_POPOVER_TABS_AUTOCLOSE_SCROLL_INTO_VIEW:
    'centerToCustomRelativePopoverTabsAutoCloseScrollIntoView',
  CENTER_TO_CUSTOM_RELATIVE_POPOVER_TABS: 'centerToCustomRelativePopoverTabs',
  CENTER_TO_CUSTOM_RELATIVE_POPOVER: 'centerToCustomRelativePopover',
  EMBEDDED: 'embedded',
  EMBEDDED_WITH_SEARCH_BAR: 'embeddedWithSearchBar',
  MODAL_POPOVER_AUTOCLOSE: 'modalPopoverAutoClose',
  MODAL_POPOVER_WITH_SEARCH_BAR_AUTOCLOSE: 'modalPopoverWithSearchBarAutoClose',
  MODAL_POPOVER_WITH_SEARCH_BAR: 'modalPopoverWithSearchBar',
  MODAL_POPOVER: 'modalPopover',
  MODAL_POPOVERS_AUTOCLOSE: 'modalPopoversAutoClose',
  MODAL_POPOVERS_HORIZONTAL_AUTOCLOSE: 'modalPopoversHorizontalAutoClose',
  MODAL_POPOVERS_WITH_FILTER_SELECTOR_AUTOCLOSE: 'modalPopoversWithFilterSelectorAutoClose',
  NONE: 'none',
  NONE_WITH_SEARCH_BAR: 'noneWithSearchBar',
  RIGHT_POPOVER_AUTOCLOSE_WITH_SEARCH_BAR: 'rightPopoverAutoCloseWithSearchBar',
  RIGHT_POPOVER_AUTOCLOSE: 'rightPopoverAutoClose',
  RIGHT_POPOVER_TABS_AUTOCLOSE: 'rightPopoverTabsAutoClose',
  RIGHT_POPOVER_TABS: 'rightPopoverTabs',
  RIGHT_POPOVER_WITH_SEARCH_BAR_AUTOCLOSE: 'rightPopoverWithSearchBarAutoClose',
  RIGHT_POPOVER_WITH_SEARCH_BAR: 'rightPopoverWithSearchBar',
  RIGHT_POPOVER: 'rightPopover',
  RIGHT_POPOVERS_AUTOCLOSE: 'rightPopoversAutoClose',
  RIGHT_POPOVERS_WITH_FILTER_SELECTOR_AUTOCLOSE: 'rightPopoversWithFilterSelectorAutoClose',
  TABS: 'tabs'
}

export const BASE_ELEMENTS_TYPES = {
  BUTTON: 'button',
  DIV: 'div',
  FIELDSET: 'fieldset',
  LABEL: 'label',
  LEGEND: 'legend'
}

export const FILTER_WRAPPER_TYPES_WITH_FIELDSET = [
  TYPES.MODAL_POPOVERS_AUTOCLOSE,
  TYPES.MODAL_POPOVERS_HORIZONTAL_AUTOCLOSE,
  TYPES.MODAL_POPOVERS_WITH_FILTER_SELECTOR_AUTOCLOSE,
  TYPES.NONE_WITH_SEARCH_BAR,
  TYPES.RIGHT_POPOVERS_AUTOCLOSE,
  TYPES.RIGHT_POPOVERS_WITH_FILTER_SELECTOR_AUTOCLOSE,
  TYPES.TABS
]

export const SELECT_POPOVER_POSITIONS = {
  BOTTOM_LEFT: 'bottomLeft',
  CENTER_TO_CUSTOM_RELATIVE: 'centerToCustomRelative',
  MODAL: 'modal',
  RIGHT: 'right'
}

export const WRAPPERS = {
  [TYPES.BOTTOM_LEFT_POPOVER_TABS]: (
    <FilterWrapperBasicSelectPopover position={SELECT_POPOVER_POSITIONS.BOTTOM_LEFT} wrapper={TYPES.TABS} />
  ),
  [TYPES.BOTTOM_LEFT_POPOVER_TABS_AUTOCLOSE]: (
    <FilterWrapperBasicSelectPopover autoclose position={SELECT_POPOVER_POSITIONS.BOTTOM_LEFT} wrapper={TYPES.TABS} />
  ),
  [TYPES.BOTTOM_LEFT_POPOVER]: (
    <FilterWrapperBasicSelectPopover position={SELECT_POPOVER_POSITIONS.BOTTOM_LEFT} wrapper={TYPES.EMBEDDED} />
  ),
  [TYPES.CENTER_TO_CUSTOM_RELATIVE_POPOVER_AUTOCLOSE]: (
    <FilterWrapperBasicSelectPopover
      autoclose
      position={SELECT_POPOVER_POSITIONS.CENTER_TO_CUSTOM_RELATIVE}
      wrapper={TYPES.EMBEDDED}
    />
  ),
  [TYPES.CENTER_TO_CUSTOM_RELATIVE_POPOVER_AUTOCLOSE_SCROLL_INTO_VIEW_WITH_SEARCH_BAR]: (
    <FilterWrapperBasicSelectPopover
      autoclose
      position={SELECT_POPOVER_POSITIONS.CENTER_TO_CUSTOM_RELATIVE}
      scrollIntoView
      withSearchBar
      wrapper={TYPES.EMBEDDED}
    />
  ),
  [TYPES.CENTER_TO_CUSTOM_RELATIVE_POPOVER_TABS]: (
    <FilterWrapperBasicSelectPopover
      position={SELECT_POPOVER_POSITIONS.CENTER_TO_CUSTOM_RELATIVE}
      wrapper={TYPES.TABS}
    />
  ),
  [TYPES.CENTER_TO_CUSTOM_RELATIVE_POPOVER_TABS_AUTOCLOSE_SCROLL_INTO_VIEW]: (
    <FilterWrapperBasicSelectPopover
      autoclose
      position={SELECT_POPOVER_POSITIONS.CENTER_TO_CUSTOM_RELATIVE}
      scrollIntoView
      wrapper={TYPES.TABS}
    />
  ),
  [TYPES.CENTER_TO_CUSTOM_RELATIVE_POPOVER]: (
    <FilterWrapperBasicSelectPopover
      position={SELECT_POPOVER_POSITIONS.CENTER_TO_CUSTOM_RELATIVE}
      wrapper={TYPES.EMBEDDED}
    />
  ),
  [TYPES.CENTER_TO_CUSTOM_RELATIVE_POPOVER_SCROLL_INTO_VIEW_WITH_SEARCH_BAR]: (
    <FilterWrapperBasicSelectPopover
      position={SELECT_POPOVER_POSITIONS.CENTER_TO_CUSTOM_RELATIVE}
      scrollIntoView
      withSearchBar
      wrapper={TYPES.EMBEDDED}
    />
  ),
  [TYPES.EMBEDDED]: <FilterWrapperBasicContent withDivider />,
  [TYPES.EMBEDDED_WITH_SEARCH_BAR]: <FilterWrapperBasicContent withDivider withSearchBar />,
  [TYPES.MODAL_POPOVER_AUTOCLOSE]: (
    <FilterWrapperBasicSelectPopover autoclose position={SELECT_POPOVER_POSITIONS.MODAL} wrapper={TYPES.EMBEDDED} />
  ),
  [TYPES.MODAL_POPOVER_WITH_SEARCH_BAR]: (
    <FilterWrapperBasicSelectPopover position={SELECT_POPOVER_POSITIONS.MODAL} withSearchBar wrapper={TYPES.EMBEDDED} />
  ),
  [TYPES.MODAL_POPOVER_WITH_SEARCH_BAR_AUTOCLOSE]: (
    <FilterWrapperBasicSelectPopover
      autoclose
      position={SELECT_POPOVER_POSITIONS.MODAL}
      withSearchBar
      wrapper={TYPES.EMBEDDED}
    />
  ),
  [TYPES.MODAL_POPOVER]: (
    <FilterWrapperBasicSelectPopover position={SELECT_POPOVER_POSITIONS.MODAL} wrapper={TYPES.EMBEDDED} />
  ),
  [TYPES.MODAL_POPOVERS_AUTOCLOSE]: (
    <FilterWrapperBasicSelectPopovers autoclose position={SELECT_POPOVER_POSITIONS.MODAL} wrapper={TYPES.EMBEDDED} />
  ),
  [TYPES.MODAL_POPOVERS_HORIZONTAL_AUTOCLOSE]: (
    <FilterWrapperBasicSelectPopovers
      alignment={SELECT_POPOVERS_ALIGNMENTS.HORIZONTAL}
      autoclose
      position={SELECT_POPOVER_POSITIONS.MODAL}
      wrapper={TYPES.EMBEDDED}
    />
  ),
  [TYPES.MODAL_POPOVERS_WITH_FILTER_SELECTOR_AUTOCLOSE]: (
    <FilterWrapperBasicSelectPopovers
      autoclose
      position={SELECT_POPOVER_POSITIONS.MODAL}
      withFilterSelector
      wrapper={TYPES.EMBEDDED}
    />
  ),
  [TYPES.NONE]: <FilterWrapperBasicContent isFullWidth withLabel={false} />,
  [TYPES.NONE_WITH_SEARCH_BAR]: <FilterWrapperBasicContent isFullWidth withSearchBar />,
  [TYPES.RIGHT_POPOVER_AUTOCLOSE_WITH_SEARCH_BAR]: (
    <FilterWrapperBasicSelectPopover
      autoclose
      position={SELECT_POPOVER_POSITIONS.RIGHT}
      withSearchBar
      wrapper={TYPES.EMBEDDED}
    />
  ),
  [TYPES.RIGHT_POPOVER_AUTOCLOSE]: (
    <FilterWrapperBasicSelectPopover autoclose position={SELECT_POPOVER_POSITIONS.RIGHT} wrapper={TYPES.EMBEDDED} />
  ),
  [TYPES.RIGHT_POPOVER_TABS_AUTOCLOSE]: (
    <FilterWrapperBasicSelectPopover autoclose position={SELECT_POPOVER_POSITIONS.RIGHT} wrapper={TYPES.TABS} />
  ),
  [TYPES.RIGHT_POPOVER_TABS]: (
    <FilterWrapperBasicSelectPopover position={SELECT_POPOVER_POSITIONS.RIGHT} wrapper={TYPES.TABS} />
  ),
  [TYPES.RIGHT_POPOVER_WITH_SEARCH_BAR]: (
    <FilterWrapperBasicSelectPopover position={SELECT_POPOVER_POSITIONS.RIGHT} withSearchBar wrapper={TYPES.EMBEDDED} />
  ),
  [TYPES.RIGHT_POPOVER_WITH_SEARCH_BAR_AUTOCLOSE]: (
    <FilterWrapperBasicSelectPopover
      autoclose
      position={SELECT_POPOVER_POSITIONS.RIGHT}
      withSearchBar
      wrapper={TYPES.EMBEDDED}
    />
  ),
  [TYPES.RIGHT_POPOVER]: (
    <FilterWrapperBasicSelectPopover position={SELECT_POPOVER_POSITIONS.RIGHT} wrapper={TYPES.EMBEDDED} />
  ),
  [TYPES.RIGHT_POPOVERS_AUTOCLOSE]: (
    <FilterWrapperBasicSelectPopovers autoclose position={SELECT_POPOVER_POSITIONS.RIGHT} wrapper={TYPES.EMBEDDED} />
  ),
  [TYPES.RIGHT_POPOVERS_WITH_FILTER_SELECTOR_AUTOCLOSE]: (
    <FilterWrapperBasicSelectPopovers
      autoclose
      position={SELECT_POPOVER_POSITIONS.RIGHT}
      withFilterSelector
      wrapper={TYPES.EMBEDDED}
    />
  ),
  [TYPES.TABS]: <FilterWrapperBasicTabs />
}
